module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("[" + _vm._s(_vm.community.tag) + "]")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.community.name))]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.optionalCommunityWebsite)
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "to": {
        name: 'communityDetails',
        params: {
          communitySlug: _vm.community.slug
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c9d2e3f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityListRow.vue
// module id = 482
// module chunks = 0